/**
 * @name MenuColumns
 * @description Componente para gestionar las columnas del reporte
 * @author Ricardo Guerra
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import styled from 'styled-components';

// Material-UI
import MuiPopover from '@material-ui/core/Popover';
import MuiList from '@material-ui/core/List';
import MuiListItem from '@material-ui/core/ListItem';
import MuiListItemIcon from '@material-ui/core/ListItemIcon';
import MuiListItemText from '@material-ui/core/ListItemText';

import { Flex, MUI, Unicons, Typography } from '@styles';

class MenuColumns extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorMenu: null
    };
  }

  openMenu = (event) => {
    this.setState({ anchorMenu: event.currentTarget });
  };

  closeMenu = () => {
    this.setState({ anchorMenu: null });
  };

  render() {
    return (
      <>
        <MUI.Tooltip title={i18n.t('Report.columns')}>
          <MUI.ButtonIcon onClick={this.openMenu}>
            <Unicons.Grids />
          </MUI.ButtonIcon>
        </MUI.Tooltip>

        <Popover
          open={Boolean(this.state.anchorMenu)}
          anchorEl={this.state.anchorMenu}
          onClose={this.closeMenu}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Flex.Col padding="16px 16px 0">
            <Typography.H6>{i18n.t('Report.columns')}</Typography.H6>
            <Typography.Small>{i18n.t('Report.selectColumnsToShow')}</Typography.Small>
          </Flex.Col>

          <List component="nav" aria-label="column-list">
            {/* Columnas */}
            {this.props.columns.map((column, index) => (
              <ListItem
                button
                key={index}
                disabled={!column.enableHiding}
                onClick={() => this.props.onHideColumn(column)}
              >
                <ListItemIcon>
                  {!column.hidden ? <Unicons.Check /> : <Unicons.Close />}
                </ListItemIcon>
                <ListItemText primary={column.header} />
              </ListItem>
            ))}
          </List>
        </Popover>
      </>
    );
  }
}

MenuColumns.propTypes = {
  // Colección de columnas a mostrar en el grid. 
  columns: PropTypes.array.isRequired,
  // Función que se ejecuta cuando se cambia la visibilidad de una columna.
  onHideColumn: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Popover = styled(MuiPopover)`
  .MuiPopover-paper {
    border-radius: 6px;
    border: 1px solid ${(props) => props.theme.colors.greyLight};
    box-shadow: ${(props) => props.theme.shadows.depth4};
  }
`;

const List = styled(MuiList)`
  &.MuiList-padding {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;

const ListItem = styled(MuiListItem)`
  &.MuiListItem-root {
    min-height: 40px;
    padding: 0px 16px;
  }

  & > a {
    text-decoration: none;
  }
`;

const ListItemIcon = styled(MuiListItemIcon)`
 &.MuiListItemIcon-root {
   min-width: 0;
   padding-right: 16px;
   color: ${(props) => props.theme.colors.greyDark};
 }

 .MuiSvgIcon-root {
   font-size: 20px;
 }
`;

const ListItemText = styled(MuiListItemText)`
  .MuiTypography-root {
    font-family: 'Bryant Pro Regular';
    font-variant: tabular-nums;
    font-size: ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: 1.3;
    letter-spacing: 0.0175em;
    color: ${(props) => props.theme.colors.greyDark};
    text-decoration: none;
  }
`;

export default MenuColumns;